/**
 * The instrument's OWN price for display: last trade, else mark, else the bid/ask mid.
 *
 * Deliberately never `indexPrice` (or `underlyingPrice`): those are the underlying's price,
 * not this instrument's. Falling back to them made a row jump between its own price and
 * the index as ticks with and without a last/mark alternated, and stamped the underlying
 * onto every option strike. Returns undefined when the tick carries no own price — show
 * a placeholder then, not the index.
 */
export function displayPriceOf(
  ticker:
    | {
        lastPrice?: string
        markPrice?: string
        bidPrice?: string
        askPrice?: string
        bestBidPrice?: string
        bestAskPrice?: string
      }
    | null
    | undefined
): string | undefined {
  if (!ticker) return undefined
  if (isPositive(ticker.lastPrice)) return ticker.lastPrice
  if (isPositive(ticker.markPrice)) return ticker.markPrice
  return midPriceOf(ticker)
}

/** Bid/ask mid when both sides are quoted (Ticker's bid/ask or IncrementalTicker's best*). */
export function midPriceOf(ticker: {
  bidPrice?: string
  askPrice?: string
  bestBidPrice?: string
  bestAskPrice?: string
}): string | undefined {
  const bid = Number(ticker.bidPrice ?? ticker.bestBidPrice)
  const ask = Number(ticker.askPrice ?? ticker.bestAskPrice)
  if (!(bid > 0) || !(ask > 0)) return undefined
  return String((bid + ask) / 2)
}

function isPositive(value: string | undefined): value is string {
  return !!value && Number(value) > 0
}
